import { firebaseAuth, firebaseauth,sto } from './../../config/firebaseconfig'
import { creatingGroupsFailure } from './groups';
import { BrowserRouter as Route, Redirect } from 'react-router-dom'
import clearUserAssesment from '../modules/assessment';
import { clearIndicator } from '../modules/assessmentIndicator';
// import mgetUser from './../../helpers/authUser'
import {unsetCompareMode} from './assessment'

localStorage.setItem('is_loader',0);

const AUTH_USER = 'AUTH_USER'
const UNAUTH_USER = 'UNAUTH_USER'
const FETCHING_USER = 'FETCHING_USER'
const FETCHING_USER_FAILURE = 'FETCHING_USER_FAILURE'
const FETCHING_USER_SUCCESS = 'FETCHING_USER_SUCCESS'
const REMOVE_FETCHING_USER = 'REMOVE_FETCHING_USER'
const AUTH_USER_FAILURE = 'AUTH_USER_FAILURE'
const SET_USER_DEV_ONLY = 'SET_USER_DEV_ONLY'
const U_FETCHING_ALL_USERS = 'U_FETCHING_ALL_USERS'
const U_FETCHING_ALL_USERS_SUCCESS = 'U_FETCHING_ALL_USERS_SUCCESS'
const U_FETCHING_ALL_USERS_ERROR = 'U_FETCHING_ALL_USERS_ERROR'
const U_AUTHING_EDUCATOR = 'U_AUTHING_EDUCATOR'
const U_AUTHING_EDUCATOR_SUCCESS = 'U_AUTHING_EDUCATOR_SUCCESS'
const U_AUTHING_EDUCATOR_ERROR = 'U_AUTHING_EDUCATOR_ERROR'
const U_SET_TEST_USER = 'U_SET_TEST_USER'
const U_AUTHING_USER = 'U_AUTHING_USER'
const U_AUTHING_USER_SUCCESS = 'U_AUTHING_USER_SUCCESS'
const U_AUTHING_USER_ERROR = 'U_AUTHING_USER_ERROR'
const LOGOUT_USER = 'LOGOUT_USER'
const LOGOUTSUCCESS = 'LOGOUTSUCCESS'
const CHECK_AUTH = 'CHECK_AUTH' 



const ENABLE_CLASS_DROPDOWN = 'ENABLE_CLASS_DROPDOWN'
const ENABLE_TEACHER_DROPDOWN = 'ENABLE_TEACHER_DROPDOWN'
const DISABLE_CLASS_DROPDOWN = 'DISABLE_CLASS_DROPDOWN'
const DISABLE_TEACHER_DROPDOWN = 'DISABLE_TEACHER_DROPDOWN'
const TEACHER_SELECTED_DROPDOWN = 'TEACHER_SELECTED_DROPDOWN'
const CLASSES_SELECTED_DROPDOWN = 'CLASSES_SELECTED_DROPDOWN'
const STUDENT_SELECTED_DROPDOWN = 'STUDENT_SELECTED_DROPDOWN'
const SCHOOL_SELECTED_DROPDOWN = 'SCHOOL_SELECTED_DROPDOWN'
const ON_CHECKOUT = "ON_CHECKOUT"

const CHANGE_SELECTED_YEAR  = 'CHANGE_SELECTED_YEAR '
 

export function onCheckout(pathname){
  return{
    type : ON_CHECKOUT,
    pathname
  }
}


export function authingUser() {
  return {
    type: U_AUTHING_USER,
  }
}

export function checkLogin(){
  return (dispatch) => {
    dispatch(fetchingUser())
    firebaseauth.onAuthStateChanged((user)=> {
      if(user){
        return dispatch(fetchingUserSuccess(user.uid, user, user.metadata.a))
      }else{
        return dispatch(fetchingUserFailure('not logged in'))
      }
    })
  }
}


export function authingUserSuccess(user) {
  localStorage.setItem('user',JSON.stringify(user)) 
  return {
    type: U_AUTHING_USER_SUCCESS,
    user,
  }
}

export function authingUserError(error) {
  return {
    type: U_AUTHING_USER_ERROR,
    error,
  }
}
 
export function setTestUser(user) {
  return {
    type: U_SET_TEST_USER,
    user,
  }
}

export function authingEducator() {
  return {
    type: U_AUTHING_EDUCATOR,
  }
}

export function authingEducatorSuccess(educator) {
  return {
    type: U_AUTHING_EDUCATOR_SUCCESS,
    educator,
  }
}

export function authingEducatorError(error) {
  return {
    type: U_AUTHING_EDUCATOR_ERROR,
    error,
  }
}

export function authUser (uid) {
  return {
    type: AUTH_USER,
    uid
  }
}

export function unauthUser () {
  console.log("iamcalled unauthUser")
  unsetCompareMode()
  return {
    type: UNAUTH_USER
  }
}

export function authUserFailure (error) {
  return {
    type: AUTH_USER_FAILURE,
    error
  }
}

export function logoutUser (error) {
  unsetCompareMode()
  
  // return {
  //   type: LOGOUT_USER,
  //   error
  // }
}


export function fetchingUser () {
  return {
    type: FETCHING_USER
  }
}

export function fetchingUserFailure (error) {
  console.warn(error)
  return {
    type: FETCHING_USER_FAILURE,
    error: 'Error fetching user.'
  }
}

export function fetchingUserSuccess (uid, user, timestamp) {
  return {
    type: FETCHING_USER_SUCCESS,
    uid,
    user,
    timestamp
  }
}
export function removeFetchingUser () {
  return {
    type: REMOVE_FETCHING_USER
  }
}

export function setUserDevOnly (userId, userEmail, role, activeUser) {
  return {
    type: SET_USER_DEV_ONLY,
    userId,
    userEmail,
    role,
    activeUser,
  }
}

export function fetchingAllUsers () {
  return {
    type: U_FETCHING_ALL_USERS,
  }
}

export function fetchingAllUsersSuccess (usersList) {
  return {
    type: U_FETCHING_ALL_USERS_SUCCESS,
    usersList,
  }
}

export function fetchingAllUsersError (error) {
  return {
    type: U_FETCHING_ALL_USERS_ERROR,
    error,
  }
}

export function enableClass (error) {
  return {
    type: ENABLE_CLASS_DROPDOWN,
    error,
  }
}

export function enableTeacher (error) {
  return {
    type : ENABLE_TEACHER_DROPDOWN,
    error,
  }
}
export function disableClass (error) {
  return {
    type: DISABLE_CLASS_DROPDOWN,
    error,
  }
}

export function disableTeacher (error) {
  return {
    type : DISABLE_TEACHER_DROPDOWN,
    error,
  }
}

export function selectTeacher (value)
{  
   return {
     type : TEACHER_SELECTED_DROPDOWN,
     value,
     
   }
}
export function selectStudentOption (value)
{  
   return {
     type : STUDENT_SELECTED_DROPDOWN,
     value,
     
   }
}
export function selectSchoolOption (value)
{  
   return {
     type : SCHOOL_SELECTED_DROPDOWN,
     value,
     
   }
}
export function selectClasses (value)
{  
   return {
     type : CLASSES_SELECTED_DROPDOWN,
     value,
    
   }
}

function handleLogOutSuccess() {
  unsetCompareMode()
  return {
    type: UNAUTH_USER,
  //   payload: err,
  //   message: err.message,
  };
}
function handleLogOutRequest() {
  return {
    type: LOGOUTSUCCESS,
    message: 'loading',
  };
}
export function logOutAction() {
  return (dispatch) => {
    firebaseauth.signOut().then(function() {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.removeItem('students')
    localStorage.removeItem('nodes')
    localStorage.removeItem('groupUAs')
    localStorage.removeItem('userAssessment')
    localStorage.removeItem('is_loader')
    localStorage.removeItem('educators')
    

       dispatch(handleLogOutSuccess());
       
       //clear userAssesment from store
       dispatch(clearUserAssesment());

       //clear indicator
      dispatch(clearIndicator());
       
    }).catch(function(error) {
    });
}
}

export const selectedYear = (schoolYear) => dispatch => {
  dispatch({
    type: CHANGE_SELECTED_YEAR,
    schoolYear
  })
}

const localTest = JSON.parse(localStorage.getItem('user'))
const initialUserState = {
  testUser: (localStorage.getItem('token')) ? localTest:null,
  lastUpdated: 0,
  uid: '',
  email: '',
  role: null,
  isAuthed: false,
  isFetching: false,
  error: '',
  notFound: false,
  isFetchingAllUsers: false,
  usersList: null,
  activeUser: null,
  isAuthingEducator: false,
  isAuthingEducatorError: '',
  educator: null,
  isAuthing: false,
  isAuthingError: '',
  is_teacher_enable:false,
  is_class_enable : false,
  classes_selected_value : null,
  teacher_selected_value : null,
  student_selected_value : null,
  school_selected_value : null,
  customToken : '',
  checkuser : null,
  checkout : false,
  checkoutlocation : null,
  selectedYear: ''
}




export function users (state = initialUserState, action) {
  switch (action.type) {

    case ON_CHECKOUT :
    return {
      ...state ,
      checkout : true,
      checkoutlocation : action.pathname
    }

    case U_AUTHING_USER :
      return {
        ...state,
        isAuthing: true,
      }
    case U_AUTHING_USER_SUCCESS :
      return {
        ...state,
        testUser: action.user,
        isAuthing: false,
        checkout : false,
        checkoutlocation  : null
      }
    case U_AUTHING_USER_ERROR :
      return {
        ...state,
        isAuthingError: action.error,
        isAuthing: false,
      }
    case U_SET_TEST_USER :
      return {
        ...state,
        testUser: state.checkuser,
      }
    case U_AUTHING_EDUCATOR :
      return {
        ...state,
        isAuthingEducator: true,
      }
    case U_AUTHING_EDUCATOR_SUCCESS :
      return {
        ...state,
        isAuthingEducator: false,
        isAuthed: true,
        educator: action.educator,
      }
    case U_AUTHING_EDUCATOR_ERROR :
      return {
        ...state,
        isAuthingEducator: false,
        isAuthingEducatorError: action.error,
      }
    case AUTH_USER :
      return {
        ...state,
        isAuthed: true,
        uid: action.uid,
        lastUpdated: new Date,
        isFetching: false,
        checkout : false,
        checkoutlocation : null
      }
    case UNAUTH_USER :
      return {
        ...state,
        isAuthed: false,
        isFetching : false ,
        authedId: '',
        checkuser : null,
        selectedYear: ''
      }
    case LOGOUT_USER : 
      return {
        ...state,
        isAuthed : false,

      }
    case AUTH_USER_FAILURE :
      return {
        ...state,
        lastUpdated: 0,
        uid: '',
        email: '',
        role: null,
        isAuthed: false,
        isFetching: false,
        error: action.error,
        notFound: true
      }
    case FETCHING_USER :
      return {
        ...state,
        isFetching: true
      }
    case FETCHING_USER_FAILURE : 
      return {
        ...state,
        isFetching: false,
        error: action.error,
        notFound: true
      }
    case REMOVE_FETCHING_USER :
      return {
        ...state,
        isFetching: false
      }
    case FETCHING_USER_SUCCESS :
      return action.user === null
        ? {
          ...state,
          isFetching: false,
          error: '',
          testUser : state.checkuser
        }
        : {
          ...state,
          isFetching: false,
          error: '',
          lastUpdated: action.timestamp,
          uid: action.uid,
          email: action.user.email,
          role: action.user.role,
          notFound: false,
          isAuthed:true
        }
      case SET_USER_DEV_ONLY :
        return {
          ...state,
          uid: action.userId,
          email: action.userEmail,
          role: action.role,
          activeUser: action.activeUser,
        }
      case U_FETCHING_ALL_USERS : 
        return {
          ...state,
          isFetchingAllUsers: true,
        }
      case U_FETCHING_ALL_USERS_SUCCESS : 
        return {
          ...state,
          isFetchingAllUsers: false,
          usersList: action.usersList,
        }
      case U_FETCHING_ALL_USERS_ERROR :
        return {
          ...state,
          isFetchingAllUsers: false,
          error: action.error,
        }
        case ENABLE_CLASS_DROPDOWN :
        return {
          ...state,
          is_class_enable: true,
          error: action.error,
        }
        case ENABLE_TEACHER_DROPDOWN :
        return {
          ...state,
          is_teacher_enable: true,
          error: action.error,
        }
        case DISABLE_CLASS_DROPDOWN :
        return {
          ...state,
          is_class_enable: false,
          error: action.error,
        }
        case DISABLE_TEACHER_DROPDOWN :
        return {
          ...state,
          is_teacher_enable: false,
          error: action.error,
        }
        case TEACHER_SELECTED_DROPDOWN:
        return {
          ...state,
          teacher_selected_value : action.value
        }
        case CLASSES_SELECTED_DROPDOWN:
        return {
          ...state,
          classes_selected_value : action.value
        }
        case STUDENT_SELECTED_DROPDOWN:
        return {
          ...state,
          student_selected_value : action.value
        }
        case SCHOOL_SELECTED_DROPDOWN:
        return {
          ...state,
          school_selected_value: action.value
        }
        case LOGOUTSUCCESS :
        return {
          ...state
        }
        case CHANGE_SELECTED_YEAR : 
        return {
        ...state,
        selectedYear: action.schoolYear
      }
        // case NEW_GET_USER :
        // return {

        // }
    default :
      return state
  }
}


// WEBPACK FOOTER //
// ./src/redux/modules/users.js